<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    塘朗站<br>
站点介绍<br>
塘朗站隶属于深圳地铁5号线（环中线），位于深圳市南山区塘朗车辆段旁，延留仙大道呈东西走向布设。车站东邻长岭陂站，西邻大学城站。该站为高架站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:11	23:40	5号线	3分钟	5分25秒<br>
黄贝岭	06:25	23:40	5号线	3分钟	5分25秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:03	23:40	5号线	4分钟	6分钟<br>
黄贝岭	06:35	23:40	5号线	4分钟	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:03	00:40	5号线	4分钟	6分钟<br>
黄贝岭	06:35	00:40	5号线	4分钟	6分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
留仙大道南侧（西）、塘朗城君璞酒店、塘朗城<br><br>
B出入口:<br>
留仙大道南侧（东）、塘朗城君璞酒店、塘朗地铁车辆段、深圳地铁运营集团客运一分公司、塘朗城、朗麓家园、南方科技大学教育集团（南山）第二实验小学、塘朗城公寓<br><br>
C出入口:<br>
留仙大道北侧（东）、塘开路、南方科技大学、深圳大学城（东）、深圳大学总医院、华晖云门、南山智园<br><br>
D出入口:<br>
留仙大道北侧（西）、深圳大学西丽校区、塘朗村、塘朗小学、塘朗大厦、福光新村、中国科学院深圳先进技术研究院<br><br>
公交换乘信息<br><br>
C出入口:<br>
公交站名： 塘朗地铁站<br>
M554、B818、M217、M343、M393、M460、高峰专线119、高峰专线120、高峰150<br><br>
B出入口:<br>
公交站名： 塘朗地铁站<br>
M554、B818、M217、M343、M393、M460、高峰专线119、高峰专线120、高峰150<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "wuhaoxian",
          title: "5号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>


